export const validationErrors = {
  TOO_SHORT: 'app/UserSettings/TOO_SHORT',
  TOO_LONG: 'app/UserSettings/TOO_LONG',
  REQUIRED: 'app/UserSettings/REQUIRED',
  NOT_VALID: 'app/UserSettings/NOT_VALID',
  NOT_MATCH: 'app/UserSettings/NOT_MATCH',
  MATCH: 'app/UserSettings/MATCH',
  NOT_CONTAINS_REQUIRED_VALUES: 'app/UserSettings/NOT_CONTAINS_REQUIRED_VALUES',
  CONTAINS_NAME: 'app/UserSettings/CONTAINS_NAME'
}

export const imageSizeOptions = {
  SMALL: 'UPLOAD_IMAGE_SIZE_SMALL',
  MEDIUM: 'UPLOAD_IMAGE_SIZE_MEDIUM',
  LARGE: 'UPLOAD_IMAGE_SIZE_LARGE'
}

export const MFA_ORG_ID = {
  production: '74951be4-8f72-4efc-bc7e-88f2ffb69e25',
  development: '985d153a-e8b6-4f14-a2d8-8cbe12c838d2',
  staging: '985d153a-e8b6-4f14-a2d8-8cbe12c838d2'
}

export const DEFAULT_POLICY = {
  allowReuse: false,
  blockNames: false,
  minimumLength: 8,
  maximumLength: 0,
  requiredCharacterClasses: [],
  daysToLife: 0
}

export const deviceSizeType = {
  TABLET: 'TABLET',
  PHONE: 'PHONE'
}

export const deviceType = {
  I_PAD: 'iPad',
  I_PHONE: 'iPhone',
  ANDROID: 'Android'
}

export const DEVICE_TYPE_MAP = [
  {
    keyword: deviceType.I_PAD,
    type: deviceType.I_PAD,
    sizeType: deviceSizeType.TABLET
  },
  {
    keyword: deviceType.I_PHONE,
    type: deviceType.I_PHONE,
    sizeType: deviceSizeType.PHONE
  }
]

export const mobilePages = {
  MAIN: 'MAIN',
  CALL_PHONE: 'CALL PHONE',
  PHOTO_SIZE: 'PHOTO SIZE',
  LANGUAGE: 'LANGUAGE',
  TWO_STEP_INFO: 'TWO STEP INFO',
  BETA_INFO: 'BETA INFO',
  PASSWORD: 'PASSWORD',
  CHECK_FOR_UPDATES: 'CHECK_FOR_UPDATES',
  ENABLE_BETA_APP: 'ENABLE_BETA_APP',
  TWO_FA: 'TWO_FA',
  SHOW_QR_CODE: 'SHOW_QR_CODE'
}

export const imageSizeIds = {
  UPLOAD_IMAGE_SIZE_SMALL: 'photoSizeSelection_small',
  UPLOAD_IMAGE_SIZE_MEDIUM: 'photoSizeSelection_medium',
  UPLOAD_IMAGE_SIZE_LARGE: 'photoSizeSelection_large'
}
export const imageSizeFromId = {
  photoSizeSelection_small: 'SMALL',
  photoSizeSelection_medium: 'MEDIUM',
  photoSizeSelection_large: 'LARGE'
}
export const PHOTO_SIZE = ['SMALL', 'MEDIUM', 'LARGE']

export const SERVICE_LINE = '+43 1 890 32 27 27'

export const TWO_FA_DIALOG_TYPES = {
  ACTIVE: 'active',
  DEACTIVE: 'deactive'
}

export const emailAndPasswordRequestCodeErrorOptions = {
  UNAVAILABLE_EMAIL: ['docu-tools-users-28', 'users-1-28'],
  INVALID_PASSWORD: ['docu-tools-users-8', 'users-1-8'],
  REUSE_OLD_PASSWORD: ['docu-tools-users-39', 'users-1-39']
}

export const userLoginType = {
  SSO: 'SAML',
  DEFAULT: 'Password'
}

export const activeAndDeactive2FARequestCodeErrorOptions = {
  INVALID_PASSWORD: ['docu-tools-users-8', 'users-1-8'],
  INVALID_VERIFICATION_CODE: ['docu-tools-users-31', 'users-1-31']
}

export const options2FA = {
  OTP: 'OTP',
  SMS: 'SMS'
}

export const handle2FAOptions = {
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate'
}

export const passwordRules = {
  MIN: 'min',
  MAX: 'max',
  CLASSES: 'classes',
  BLOCK_NAMES: 'blockNames'
}

export const passwordPolicyClassesOptions = {
  UPPER_CASE: 'UPPER_CASE',
  LOWER_CASE: 'LOWER_CASE',
  SPECIAL: 'SPECIAL',
  NUMBERS: 'NUMBERS'
}
